import { LogErrors } from './../../LogErrors'
import { DoubleAttempt } from './../Helpers/DoubleAttempt'


/**
 * Ejecuta el movimiento de grupos de un instructor origen a uno destino.
 * @param {Object} payload - Objeto con ids de origen, destino, grupos, centro y rol.
 * @param {string} token - Token de autorización.
 */
const UpdateGroupInstructor = async (payload, token) => {
    try {
        const parameters = {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': token
            },
            body: JSON.stringify(payload)
        }

        const url = `${process.env.REACT_APP_API_URL}/api/V5/Leaders/UpdateGroupInstructor`
        
        // Asumiendo que DoubleAttempt maneja métodos PATCH, en caso contrario usar fetch directo
        const response = await DoubleAttempt(url, parameters)

        // Verificamos si la respuesta es exitosa (estado 200)
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('UpdateGroupInstructor - DL Leaders ChangeGroup', error)
        return { success: false, message: 'No ha sido posible transferir los grupos al nuevo instructor.' }
    }
}

export { UpdateGroupInstructor };